import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { motion } from "framer-motion"
import { useTranslation } from "react-i18next";
const Switch = (props) => {
  const { t } = useTranslation(['devices', 'common']);
  const [alert, setAlert] = React.useState(null);

  const getParentName = (id) => {
    const index = props.switches?.findIndex((s) => s.id === id);
    if (index === -1) return id;
    return props.switches[index].name;
  }

  const getFeatures = () => {
    return (<>
      {props.autoOn && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:autoOn')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">{props.autoOn}s</div>
      </Col></>}

      {props.autoOff && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:autoOff')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">{props.autoOff}s</div>
      </Col></>}

      {props.isAutoNight && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:autoNight')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">ON</div>
      </Col></>}
      {props.isAutoDay && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:autoDay')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">ON</div>
      </Col></>}
      {props.isReverted && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:reverted')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">ON</div>
      </Col></>}
      {props.isCyclic.enabled && <><Col xs="6" className="sw_infos">
        <div className="sw_infos_title">{t('common:cyclic')}</div>
      </Col>
      <Col xs="6" className="sw_infos">
        <div className="sw_infos_value">ON</div>
      </Col></>}
    </>)
  }

  const defaultView = () => {
    return (<>
              <Row className="sw_top h-100">
                <Col xl="9" xs="10" className="sw_desc" onClick={() => props.switchEnterEditMode(props.id)}>
                  <Row>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_title">{t('common:name')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_value">{props.name || t('common:notSetup')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_title">{t('common:command')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_value">{props.command ? `${props.commandPrefix}${props.command}` : t('common:notSetup')}</div>
                    </Col>
                    {getFeatures()}
                  </Row>
                </Col>
                <Col xl="3" xs="2" className="m-auto" onClick={() => props.switchBtn(props.id, !props.state)}>
                  <img className="sw_img" alt="state" src={props.isSAM ? props.state ? `https://rustlink.io/static/discord/samOn.png` : `https://rustlink.io/static/discord/samOff.png` : props.state ? `https://rustlink.io/static/discord/switchOn.png` : `https://rustlink.io/static/discord/switchOff.png`} />
                </Col>
              </Row>
      </>)
  }
  
  const linkedView = () => {
    return (<>
            <Row className="sw_top h-100">
                <Col xl="9" xs="10" className="sw_desc" onClick={() => props.switchEnterEditMode(props.id)}>
                  <Row>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_title">{t('common:name')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_value">{props.name || t('common:notSetup')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_title">{t('linked')}</div>
                    </Col>
                    <Col xs="6" className="sw_infos">
                      <div className="sw_infos_value">{getParentName(props.parent)}</div>
                    </Col>
                  </Row>
                </Col>
                <Col xl="3" xs="2" className="m-auto">
                  <img className="sw_img" alt="state" src={props.isSAM ? props.state ? `https://rustlink.io/static/discord/samOn.png` : `https://rustlink.io/static/discord/samOff.png` : props.state ? `https://rustlink.io/static/discord/switchOn.png` : `https://rustlink.io/static/discord/switchOff.png`} />
                </Col>
              </Row>
    </>)
  }

  const deleteConfirmation = (id) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:confirmUnlist')}
        onConfirm={() => successRemove(id)}
        onCancel={() => cancelRemove()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t('common:confirmYes')}
        cancelBtnText={t('common:cancel')}
        showCancel
        btnSize=""
      >
      </ReactBSAlert>
    );
  };
  
  const successRemove = (id) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:removed')}
        onConfirm={() => hideAlert(id)}
        onCancel={() => hideAlert(false)}
        confirmBtnBsStyle="success"
        btnSize=""
      >
        {t('deviceUnlisted')}
      </ReactBSAlert>
    );
  };
  const cancelRemove = () => {
    setAlert(
      <ReactBSAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={t('common:cancelled')}
        onConfirm={() => hideAlert(false)}
        onCancel={() => hideAlert(false)}
        confirmBtnBsStyle="success"
        btnSize=""
      >
      </ReactBSAlert>
    );
  };
  
  const hideAlert = (id = false) => {
    setAlert(null);
    if (id) {
      props.switchDelete(id);
    }
  };

  return (
    <>
      {alert}
      <Col xl="4" lg="6" md="6" xs="12">
      <motion.div 
        whileHover={{ scale: 1.03 }}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1}}
        transition={{ duration: 0.2 }}
      >
        <Card>
          <CardBody className="sw_body">
          <div className="sw_btns"><i className="sw_icons tim-icons icon-settings-gear-63" onClick={() => props.switchEnterEditMode(props.id)}/><i className="sw_icons tim-icons icon-simple-remove" onClick={() => deleteConfirmation(props.id)} /></div>
            {props.parent ? linkedView() : defaultView()}
          </CardBody>
        </Card>
        </motion.div>
      </Col>
    </>
  );
};

export default Switch;